/**
 * Drag and Drop types
 * @type {string}
 */
export const NODE_ITEM_CONTENT = 'NODE_ITEM_CONTENT';
export const NODE_ITEM_CTA = 'NODE_ITEM_CTA';
export const CTA_COMPONENT = 'CTA_COMPONENT';
export const CONTENT_COMPONENT = 'CONTENT_COMPONENT';
export const AB_COMPONENT = 'AB_COMPONENT';
export const AB_NODE = 'AB_NODE';

/**
 * CTA types
 * @type {string}
 */
export const CTA_WEBSITE = 'CTA_WEBSITE';
export const CTA_CALL = 'CTA_CALL';
export const CTA_EMAIL = 'CTA_EMAIL';
export const CTA_OWN_ANCHOR = 'CTA_OWN_ANCHOR';
export const CTA_OTHER_CONTENT = 'CTA_OTHER_CONTENT';
export const CTA_TRIGGER_EVENT = 'CTA_TRIGGER_EVENT';
export const CTA_CUSTOM = 'CTA_CUSTOM';
export const CTA_JOIN_SEGMENT = 'CTA_JOIN_SEGMENT';
export const CTA_ACTIVATE_BROADCAST = 'CTA_ACTIVATE_BROADCAST';

/**
 * Node types
 * @type {string}
 */
export const ROOT_NODE = 'ROOT_NODE';
export const NODE_INIT = 'NODE_INIT';
export const NODE_END_OF_CONTENT = 'NODE_END_OF_CONTENT';
export const NODE_CTA = 'NODE_CTA';

/**
 * Card event type
 */
export const EVENT_CARD = 'EVENT_CARD';

/**
 * Update status
 * @type {string}
 */
export const NORMAL = 'NORMAL';
export const OUT_OF_DATE = 'OUT_OF_DATE';
export const UP_TO_DATE = 'UP_TO_DATE';



// WEBPACK FOOTER //
// ./src/constants/ItemTypes.js